<template>
    <div style="align-items: baseline">
        <div style="display: flex; align-items: center; ">
            <img :src="logoUrl" alt="Avatar"
                 style="width: 28vw;">
        </div>
        <div class="mt-2 justify-center" style="display: flex; margin-bottom: 13px;">
            <div class="app-name-panel">{{textItem}}</div>
        </div>
      <div class="mt-2 justify-center" style="display: flex; margin-bottom: 13px;">
        <div class="app-sub-name-panel">{{subTextItem}}</div>
      </div>
    </div>
</template>

<script>
    export default {
        props: ["textItem","subTextItem"],
        data() {
            return{
              logoUrl: 'https://cdn01.immigration.gov.np/public/images/tourist/nepaliport_logo.png',
            }
        }
    };
</script>
